// @ts-nocheck
import { useEffect, useState } from "react";
// import "./ModalComponents.css";
import Select from "react-select";

const SatelliteProfileModalDropdown = ({ options, isMulti, handleSelectedOption, previousOption }) => {
    const [selectedOption, setSelectedOption] = useState<any>(null); // Set initial state to null

    const handleSelection = (e) => {
        setSelectedOption(e);
        handleSelectedOption(e);
    };

    useEffect(() => {
        if (previousOption) {
            setSelectedOption({
                label: previousOption,
                value: previousOption,
            });
        }
    }, [previousOption]);

    return (
        <Select
            className="modalSelectBtn"
            placeholder="Select Dropdown"
            value={selectedOption}
            options={options}
            onChange={handleSelection}
            isMulti={isMulti === "true" ? true : false}
            styles={{
                control: (provided, state) => ({
                    ...provided,
                    borderRadius: "4px",
                    border: "0.5px solid rgba(204, 245, 78, 0.20)",
                    backgroundColor: "transparent",
                }),
                menu: (provided) => ({
                    ...provided,
                    backgroundColor: "rgba(5,5,5)",
                }),
                option: (provided, state) => ({
                    ...provided,
                    fontSize: "12px !important",
                    backgroundColor: state.isFocused
                        ? "rgba(5,5,5)"
                        : "rgba(2,2,2)",
                    "&:hover": {
                        backgroundColor: "rgba(2,2,2)",
                        boxShadow: "none",
                        borderRadius: "4px",
                        border: "0.5px solid rgba(204, 245, 78, 0.20)",
                    },
                }),
                placeholder: (provided) => ({
                    ...provided,
                    color: "#57585A !important",
                    fontSize: "12px !important",
                }),
                singleValue: (provided) => ({
                    ...provided,
                    fontSize: "12px",
                    color: "#fff" // Set font size of selected value
                })
            }}
        />
    );
};

export default SatelliteProfileModalDropdown;